import {
    GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_LOADING,
    GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_ERROR,
    GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
    GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_LOADING,
    GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
    GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_ERROR,
    EDIT_INPATIENT_CLAIM_BY_SYSADMIN_LOADING,
    EDIT_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
    EDIT_INPATIENT_CLAIM_BY_SYSADMIN_ERROR,

    GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING,
    GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
    GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR,
    GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING,
    GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
    GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR,
    EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING,
    EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS,
    EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR,
} from '../actions';

const initialState = {
    // All Inpatient 
    allInpatientLoading: false,
    allInpatientData: [],
    allInpatientPagination: {},
    allInpatientError: null,
    // Detail Inpatient
    detailInpatientLoading: false,
    detailInpatientData: {},
    detailInpatientError: null,
    // Edit Inpatient
    editInpatientLoading: false,
    editInpatientSucess: null,
    editInpatientError: null,
    // All Outpatient
    allOutpatientLoading: false,
    allOutpatientData: [],
    allOutpatientPagination: {},
    allOutpatientError: null,
    // Detail Outpatient
    outpatientDetailLoading: false,
    outpatientDetailData: {},
    outpatientDetailError: null,
    // Edit Outpatient
    editOutpatientLoading: false,
    editOutpatientSucess: null,
    editOutpatientError: null,
};

export default function (state = initialState, action) {
    switch (action.type) {
        // All Inpatient
        case GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_LOADING:
            return Object.assign({}, state, { allInpatientLoading: true, allInpatientData: [], allInpatientPagination: {}, allInpatientError: null });
        case GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS:
            return Object.assign({}, state, { allInpatientLoading: false, allInpatientData: action.payload.inpatient, allInpatientPagination: action.payload.pagination, allInpatientError: null });
        case GET_ALL_INPATIENT_CLAIM_BY_SYSADMIN_ERROR:
            return Object.assign({}, state, { allInpatientLoading: false, allInpatientData: [], allInpatientPagination: {}, allInpatientError: action.payload });
        // Detail Inpatient
        case GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_LOADING:
            return Object.assign({}, state, { detailInpatientLoading: true, detailInpatientData: null, detailInpatientError: null });
        case GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS:
            return Object.assign({}, state, { detailInpatientLoading: false, detailInpatientData: action.payload.inpatient, detailInpatientError: null });
        case GET_DETAIL_INPATIENT_CLAIM_BY_SYSADMIN_ERROR:
            return Object.assign({}, state, { detailInpatientLoading: false, detailInpatientData: null, detailInpatientError: action.payload });
        // Edit Inpatient
        case EDIT_INPATIENT_CLAIM_BY_SYSADMIN_LOADING:
            return Object.assign({}, state, { editInpatientLoading: true, editInpatientSucess: null, editInpatientError: null });
        case EDIT_INPATIENT_CLAIM_BY_SYSADMIN_SUCCESS:
            return Object.assign({}, state, { editInpatientLoading: false, editInpatientSucess: action.payload, editInpatientError: null });
        case EDIT_INPATIENT_CLAIM_BY_SYSADMIN_ERROR:
            return Object.assign({}, state, { editInpatientLoading: false, editInpatientSucess: null, editInpatientError: action.payload });
        // All Outpatient
        case GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING:
            return Object.assign({}, state, { allOutpatientLoading: true, allOutpatientData: [], allOutpatientPagination: {}, allOutpatientError: null });
        case GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS:
            return Object.assign({}, state, { allOutpatientLoading: false, allOutpatientData: action.payload.outpatient, allOutpatientPagination: action.payload.pagination, allOutpatientError: null });
        case GET_ALL_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR:
            return Object.assign({}, state, { allOutpatientLoading: false, allOutpatientData: [], allOutpatientPagination: {}, allOutpatientError: action.payload });
        // Detail Outpatient 
        case GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING:
            return Object.assign({}, state, { detailOutpatientLoading: true, detailOutpatientData: null, detailOutpatientError: null });
        case GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS:
            return Object.assign({}, state, { detailOutpatientLoading: false, detailOutpatientData: action.payload.outpatient, detailOutpatientError: null });
        case GET_DETAIL_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR:
            return Object.assign({}, state, { detailOutpatientLoading: false, detailOutpatientData: null, detailOutpatientError: action.payload });
        // Edit Outpatient
        case EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_LOADING:
            return Object.assign({}, state, { editOutpatientLoading: true, editOutpatientSucess: null, editOutpatientError: null });
        case EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_SUCCESS:
            return Object.assign({}, state, { editOutpatientLoading: false, editOutpatientSucess: action.payload, editOutpatientError: null });
        case EDIT_OUTPATIENT_CLAIM_BY_SYSADMIN_ERROR:
            return Object.assign({}, state, { editOutpatientLoading: false, editOutpatientSucess: null, editOutpatientError: action.payload });
        default:
            return state;
    }
}